import { rem } from 'polished';
import styled from 'styled-components';
import { DESKTOP_HEADER_HEIGHT, MOBILE_HEADER_HEIGHT } from '../../constants';
import { breakpoints } from '../../styles/theme';

export const Wrapper = styled.div`
    margin-top: ${rem(MOBILE_HEADER_HEIGHT)};
    padding: ${rem(40)} 0;

    @media (min-width: ${breakpoints.sm}px) {
        margin-top: ${rem(DESKTOP_HEADER_HEIGHT)};
    }
`;

export const Message = styled.span`
    display: block;
    padding-bottom: ${rem(40)};
`;
